import React from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import InviteToOrg from 'src/components/InvitePeople/InviteToOrg/InviteToOrg'
import NotFoundRightFlyoutContent from 'src/components/NotFoundRightFlyoutContent/NotFoundRightFlyoutContent'
import RightFlyout, {
  RightFlyoutBodyWidths,
} from 'src/components/RightFlyout/RightFlyout'
import { useCurrentUser } from 'src/context/UserProvider/useUser'
import { LocationState } from 'src/redux/createRootReducer'
import { selectAppName } from 'src/redux/selectors/session.selectors'

export enum InvitePeopleScreen {
  Pick = 'Pick',
  Contact = 'Contact',
  Org = 'Org',
}

const InvitePeople: React.FC = () => {
  const appName = useSelector(selectAppName)
  const history = useHistory<LocationState>()
  const user = useCurrentUser()

  return (
    <>
      <Helmet>
        <title>{`Invite People | ${appName}`}</title>
        <meta name="description" content={`Invite People page of ${appName}`} />
      </Helmet>
      <RightFlyout width={RightFlyoutBodyWidths.Action}>
        {' '}
        {user?.hasOrgBookkeeperPermissions ? (
          <InviteToOrg
            prePopulatedEmails={
              history.location.state?.email
                ? [history.location.state?.email]
                : undefined
            }
          />
        ) : (
          <NotFoundRightFlyoutContent />
        )}
      </RightFlyout>
    </>
  )
}

export default InvitePeople
